export default "/images/dfa.png?d66ddbf366a10259c1a0147ceb073459";